<template>
  <v-layout v-resize="onResize" column style="padding-top: 0px">
    <div class="container-fluid">
      <div class="row" style="margin-top: 0px">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">Inquiry Temporary Tao Yu</div>
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <v-select
                    :items="listKotaDaftar"
                    label="Tao Ying City"
                    required
                    v-model="search_kota"
                    item-text="DESKRIPSI_DATA"
                    item-value="ID_DATA"
                    color="#F9A825"
                    v-on:change="searchData()"
                  ></v-select>
                </div>
                <div class="col">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="search_tgl_daftar"
                        label="Tao Ying Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        @blur="search_tgl_daftar_raw = parseDate(search_tgl_daftar)"
                        v-on="on"
                        color="#F9A825"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="search_tgl_daftar_raw"
                      v-on:change="searchData()"
                      color="#F9A825"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </div>
              </div>

              <v-data-table
                v-model="dataTables"
                :single-select="singleSelect"
                show-select
                item-key="ID_TRX"
                :headers="headers"
                :items="users"
                :search="search"
                :hide-default-header="isMobile"
                :class="{mobile: isMobile}"
              >
                <template v-slot:top>
                  <v-toolbar flat color="white">
                    <v-btn
                      style="margin-right: 20px"
                      color="#3EB650"
                      dark
                      @click="validateUser"
                      >Validate Data Tao Yu</v-btn
                    >
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search Tao Yu Data"
                      single-line
                      hide-details
                      color="#F9A825"
                    ></v-text-field>
                    <v-dialog
                      v-model="dialog"
                      v-if="dialog"
                      max-width="900px"
                      persistent
                    >
                      <v-card>
                        <FormDaftar
                          @onCloseDialog="onCloseDialog"
                          :data="{ editedItem }"
                          :dataKota="{ search_kota }"
                          :dataTanggal="{ search_tgl_daftar_raw }"
                        ></FormDaftar>
                      </v-card>
                    </v-dialog>
                    <v-dialog
                      v-model="dialog3"
                      v-if="dialog3"
                      max-width="35%"
                      persistent
                    >
                      <v-card>
                        <FormUploadSignature
                          @onCloseDialog="onCloseDialog"
                          :dataTaoyu="{ users }"
                          :idDatatable="id_data_table"
                        ></FormUploadSignature>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>

                <template v-slot:item.TGL_DAFTAR="{ item }">
                  <span
                    >{{ new Date(item.TGL_DAFTAR).toLocaleDateString('es-CL') }}</span
                  >
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-icon small class="mr-2" @click="editItem(item)">
                    mdi-pencil
                  </v-icon>
                  <v-icon small class="mr-2" @click="deleteItem(item)">
                    mdi-delete
                  </v-icon>
                  <v-icon
                        small
                        class="mr-2"
                        @click="printProfile(item)"
                    >
                        mdi-printer
                    </v-icon>
                  <v-icon small class="mr-2" @click="uploadSignature(item)">
                    mdi-upload
                  </v-icon>
                </template>
                <template v-slot:no-data>
                  <!-- <v-btn color="#FCC133" @click="initialize">Reset</v-btn> -->
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-layout>
</template>
<script>
import 'fix-date'
import axios from '@/axios'    
import FormDaftar from '../../components/modal/FormDaftar.vue'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
import FormUploadSignature from '../../components/modal/FormUploadSignature.vue'
export default {
    data: () => ({
        search: '',
        search_kota:'',
        search_tgl_daftar:'',
        search_tgl_daftar_raw:'',
        menu2: false,
        dialog: false,
        dialog3: false,
        listKotaDaftar:[],
        headers: [
        { text: 'Name', align: 'start',value: 'NAMA_INDO',},
        { text: 'Chinese Name (Pinyin)', value: 'NAMA_PINYIN' },
        { text: 'Chinese Name (Hanzi)', value: 'NAMA_HANZI' },
        { text: 'Tao Ying Date', value: 'TGL_DAFTAR', filterable: false },
        { text: 'Created By', value: 'LAST_UPDATE_NAME', filterable: false },
        // { text: 'Created By', value: 'CREATED_NAME', filterable: false },
        { text: 'Actions', value: 'actions', sortable: false },
        ],
        users:[],
        isMobile: false,
        editedIndex:'',
        editedItem: [],
        flagEdited:false,
        role:0,
        singleSelect: false,
        dataTables: [],
        id_data_table: ''
    }),
    watch: {
        dialog (val) {val || this.close()},
        search_tgl_daftar_raw (val) {
            this.search_tgl_daftar = this.formatDate(this.search_tgl_daftar_raw)
            // new Date(this.search_tgl_daftar_raw).toLocaleDateString('es-CL')
        },
    },
    created () {
        this.initialize()
    },
    beforeCreate: function () {
        if (!this.$session.exists()) {
        this.$router.push('/')
        }
    },
    methods: {
        onResize() {
          if (window.innerWidth < 769)
            this.isMobile = true;
          else{
            
            this.isMobile = false;
          }
        },
        initialize () {
            // console.log('Dash '+this.$session.get('token'));
            if(this.$session.get('role'))this.role=this.$session.get('role');

            this.users=[];
            axios({
                method: 'post',
                url: 'list_data_table',
                data: {
                  role_name: 'Taoyu_s',
                  user_id:this.$session.get('user_id')
                },
                headers: {
                  Authorization: 'Bearer ' + this.$session.get('token'),
                },
            }).then(response => {
                // console.log(JSON.stringify(response.data));
                this.users=response.data;
            }).catch(error=>{
                console.log('Error Fetch Data '+error);
                // var status = error.response.status
            });

            if(this.listKotaDaftar.length==0){
                    // sd6webdev.indomaret.lan/laravel-passport/public/api/master_data',
                axios({
                    method: 'post',
                    url: 'get_list_kota_daftar',
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                    data:{
                        user_id: this.$session.get('user_id')
                    }
                }).then(response => {
                    this.listKotaDaftar=response.data;
                }).catch(error=>{
                     // Swal.fire({
                     //            title:'Peringatan',
                     //            icon :'error',
                     //            text:'Failed to retrieve List City !'
                     //    });
                });

            }

        },
        formatDate (date) {
            if (!date) return null

            return new Date(date).toLocaleDateString('es-CL');
        },
        parseDate (date) {
            if (!date) return null

            return new Date(date).toLocaleDateString('sv-SE')
            // return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        editItem (item) {
            this.flagEdited=true;
            this.editedIndex = this.users.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },
        deleteItem (item) {

            confirm('Are you sure to delete this data ?') &&
            axios({
                method: 'post',
                url: 'delete_data_table',
                data: {
                  id: item.ID_TRX,
                },
                headers: {
                  Authorization: 'Bearer ' + this.$session.get('token'),
                },
            }).then(response => {
                if(response.data){
                    Swal.fire({
                                title:'Peringatan',
                                icon :'success',
                                text:response.data
                        });
                    this.initialize();
                }
            }).catch(error => {
                console.log(error.response);
            });
        },
        close () {
            this.dialog = false
            this.$nextTick(() => {
                this.editedIndex = -1
            })
        },
        searchData(){
            // alert(this.search_kota+' '+this.search_tgl_daftar);
            // alert('Search Here '+this.search_kota+' '+this.search_tgl_daftar_raw);

            if(this.search_kota!=='' || this.search_tgl_daftar_raw!==''){
                // alert("here");
                axios({
                    method: 'post',
                    url: 'get_data_taoyu_s',
                    data: {
                      kota: this.search_kota,
                      tanggal: this.search_tgl_daftar_raw,
                      nomor_taoyu: this.search
                    },
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                    this.users=response.data;
                }).catch(error=>{
                    console.log('Error Fetch Data '+error);
                    // var status = error.response.status
                });
            }
        },
        validateUser(){
            if(this.dataTables.length>0){
                // console.log(this.dataTables);
                let listId_Trx=this.dataTables.map(data => data.ID_TRX);

                confirm('Are you sure to process this data ?') &&
                axios({
                    method: 'post',
                    url: 'approval_taoyu_s',
                    data: {
                      id: listId_Trx,
                      user_id: this.$session.get('user_id')
                    },
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                    if(response.data){
                        Swal.fire({
                                title:'Peringatan',
                                icon :'success',
                                text:response.data
                        });
                        this.initialize();
                    }
                }).catch(error => {
                    console.log(error.response);
                });
            }else{
                 Swal.fire({
                                title:'Peringatan',
                                icon :'info',
                                text:'No Data Selected'
                        });

            }
        },
        onCloseDialog(){
            this.dialog2=false;
            this.dialog = false;
            this.dialog3= false;
            this.initialize()
        },
        printProfile(item){
            this.dialogLoading=true;
            console.log(item);
            const swalWithBootstrapButtons = Swal.mixin({
                                              customClass: {
                                                confirmButton: 'btn btn-success',
                                                cancelButton: 'btn btn-danger'
                                              },
                                              buttonsStyling: false
                                            })

            swalWithBootstrapButtons.fire({
             // title: 'Are you sure?',
              text: "Are you sure?",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: 'Yes, download pdf!',
              cancelButtonText: 'No, cancel!',
              reverseButtons: true
            }).then((result) => {
              if (result.isConfirmed) {
                axios({
                    method: 'post',
                    url: 'profile_data_approval_taoyu',
                    responseType: 'blob', // important
                    data:{
                        id: item.ID_TRX
                    },
                    headers: {
                      Authorization: 'Bearer ' + this.$session.get('token'),
                    },
                }).then(response => {
                    // console.log(response);
                    if(response){
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', item.NAMA_INDO+'.pdf');
                        document.body.appendChild(link);
                        link.click();
                        this.dialogLoading=false;
                        // this.initialize();
                    }
                }).catch(error => {
                    this.dialogLoading=false;
                    console.log(error.response);
                });
              } else if (
                /* Read more about handling dismissals below */
                result.dismiss === Swal.DismissReason.cancel
              ) {
                swalWithBootstrapButtons.fire(
                  'Cancelled',
                  'It is okay :)',
                  'info'
                )
                this.dialogLoading=false;
              }
            })
        },
        uploadSignature (item){
          this.id_data_table = item.ID_TRX;
          this.dialog3=true;
        },
    },
    components: {
        FormDaftar,
        FormUploadSignature
    },
}
</script>

<style>
.butt {
  padding: 10px;
  background-color: #ebaa1f;
}

.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid deeppink;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid cyan;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  width: 50%;
  height: 40px;
  font-weight: bold;
}
</style>
